import React from 'react';
import galleryImg1 from '../img/gallery/gallery-1-11.png';
import galleryImg2 from '../img/gallery/gallery-1-22.png';
import galleryImg3 from '../img/gallery/gallery-1-333.png';

const GallerySection = () => {
  return (
    <section className=" space-extra- gallery-style1">
      <div className="container">
        <div className="row">
          {/* Left Column - Text and Images */}
          <div className="col-xl-6">
            <div className="title-area">
              <span className="sec-subtitle">Reliable & Convenient</span>
              <h2 className="sec-title h1">Platinum24 Cabs</h2>
              <p className="sec-text">
                Experience top-notch taxi services with Platinum24 Cabs. 
                Available 24/7 for all your transportation needs, offering 
                safe, comfortable, and timely rides wherever you go.
              </p>
            </div>
            <div className="row">
              <div className="col-xl-6 col-sm-6">
                <img className="gallery-image" src={galleryImg1} alt="Gallery 1" />
              </div>
              <div className="col-xl-6 col-sm-6">
                <img className="gallery-image" src={galleryImg2} alt="Gallery 2" />
              </div>
            </div>
          </div>

          {/* Right Column - Video */}
          <div className="col-xl-6">
            <div className="gallery-video">
              <img src={galleryImg3} alt="Gallery Video" />
         
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
